import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=20bf2e9b&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=20bf2e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf2e9b",
  null
  
)

export default component.exports